export default function (instance) {
  instance.getProjectLineMarkerPosition = function (targetId) {
    function gridToPageCoordinates(pos, grid) {
      const gridPos = instance.utils.dom.getNodePosition(grid.$grid_data);

      const x = pos.x + gridPos.x + grid.$grid.scrollLeft;
      const y = pos.y + gridPos.y - grid.$grid_data.scrollTop;

      return { ...pos, x, y };
    }

    function setWidthWithinContainer(width) {
      const containerSize = instance.utils.dom.getNodePosition(instance.$root);

      if (width > containerSize.width) {
        width = containerSize.width - 2;
      }

      return width;
    }

    const grid = instance.$ui.getView('grid');
    const maxBottom = grid.$grid_data.getBoundingClientRect().bottom + window.scrollY;

    const level = instance.isTaskExists(targetId) ? instance.calculateTaskLevel(instance.getTask(targetId)) : 0;
    const indentNode = grid.$grid_data.querySelector('.gantt_tree_indent');

    let pos = { x: 0, y: 0 };
    let indent = 15;

    if (indentNode) {
      indent = indentNode.offsetWidth;
    }

    const iconWidth = 40;
    const itemTop = grid.getItemTop(targetId);
    const itemHeight = grid.getItemHeight(targetId);

    pos.y = itemTop + itemHeight - 2;
    pos.x = iconWidth + (level + 1) * indent;
    pos.width = setWidthWithinContainer(Math.max(grid.$grid_data.offsetWidth - pos.x, 0), pos.x);
    pos = gridToPageCoordinates(pos, grid);

    if (pos.y > maxBottom) {
      pos.y = maxBottom;
    }

    return pos;
  };
}
